module.exports = __webpack_public_path__ + "img/18.a081a3f7.png";